/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';

export const CreditScoreRangeSchema = z.enum(["NOT_PROVIDED", "NOT_REQUIRED", "POOR", "FAIR", "GOOD", "VERY_GOOD", "EXCELLENT"])
